<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow class="mb-1">
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Product List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="programCreate"
                >Create</CButton
              >
            </CCol>
            <CCol col="2">
              <CSelect
                :options="optionsCountry"
                required
                v-model="selectedCountry"
                @change="handleCountry"
              />
            </CCol>
            <CCol col="2">
              <CSelect
                :options="filteredLanguageOptions"
                required
                v-model="selectedLanguage"
                :disabled="selectedCountry === 'malaysia'"
                @change="handleLanguage"
              />
            </CCol>
            <CCol class="float-right" col="3">
              <div class="search-list">
                <CInput
                  class="float-left mb-0 mr-2"
                  placeholder="Search By Slug"
                  v-model="searchValue"
                  @input="handleSearch"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </div>
            </CCol>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="rowClicked(data.item.product_id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div class="pagination-btn-refresh" @click="getProduct('REFRESH')">
              Refresh
            </div>
            <div class="pagination-btn-back" @click="getProduct('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="getProduct('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "Product",
  props: {
    lang: {
      type: String,
      required: false,
      default: "ID"
    }
  },
  data() {
    return {
      items: [],
      allItems: [],
      searchValue: "",
      fields: [
        { key: "product_id", label: "ID" },
        { key: "service_name", label: "Nama Product" },
        { key: "priority", label: "Priority" },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      activePage: 1,
      selectedLanguage: "",
      selectedCountry: "",
      optionsLanguage: [
        { label: "Select Language", value: "" },
        { label: "Indonesia", value: "ID" },
        { label: "English", value: "EN" },
      ],
      optionsCountry: [
        { label: "Select Country", value: "" },
        { label: "Indonesia", value: "indonesia" },
        { label: "Malaysia", value: "malaysia" },
      ],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.selectedLanguage = this.lang.toUpperCase();
    this.getProduct();
  },
  computed: {
    filteredLanguageOptions() {
      if (this.selectedCountry === "malaysia") {
        return [{ label: "English", value: "EN" }];
      }

      return this.optionsLanguage;
    },
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    handleSearch() {
      this.getProduct("REFRESH");
    },
    getProduct(action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v2/product_detail/admin/data?page=${this.activePage}&per_page=20&q=${this.searchValue}&order_by=priority&priority=ASC&lang=${this.selectedLanguage || this.lang.toUpperCase()}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.allItems = response.data.data.data.map(o => ({
              ...o,
              priority: o.priority || '-'
            }));
            this.applyFilters();
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else {
            this.allItems = response.data.data.data;
            this.applyFilters();
          }
        })
        .catch((err) => {
          console.log("error :", err.response.data);
          Swal.fire({
            icon: "error",
            title: "Gagal mendapatkan list data produk",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    applyFilters() {
      this.items = this.allItems.filter((item) => {
        const matchLanguage = !this.selectedLanguage || item.product_language === this.selectedLanguage;
        const matchCountry = !this.selectedCountry || item.available_for === this.selectedCountry;

        return matchLanguage && matchCountry;
      });
    },
    handleLanguage(event) {
      this.selectedLanguage = event.target.value;
      this.getProduct("REFRESH");
    },
    handleCountry(event) {
      this.selectedCountry = event.target.value;

      if (this.selectedCountry === "malaysia") {
        this.selectedLanguage = "EN";
      }

      this.getProduct("REFRESH");
    },
    rowClicked(item) {
      const selectedLanguage = (this.selectedLanguage || this.lang).toLowerCase();
      this.$router.push({ path: `/management/product/${selectedLanguage}/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    programCreate() {
      const selectedLanguage = (this.selectedLanguage || this.lang).toLowerCase();
      this.$router.push({ path: `/management/product/create/` + selectedLanguage });
    },
  },
};
</script>

<style scoped>
@import url("./Product.css");
</style>
